import { AccountType } from '@logz-pkg/enums';
import {
  authService,
  configProvider,
  LoggerService,
  newAccountCheckApiService,
  sessionStateService,
} from '@logz-pkg/frontend-services';
import { isEmpty } from 'lodash';
import { appEmbedded } from '../../app/configs/app-embedded';
import { featureFlagStateService } from 'ui/state/feature-flag.state.service';

const checkNewAccount = async (): Promise<boolean> => {
  if (appEmbedded || !authService.isAuthenticated()) return false;

  try {
    if (isEmpty(sessionStateService.session.get())) {
      await sessionStateService.fetch();
    }

    if (featureFlagStateService.isFeatureEnabled('IgnoreNewAccount')) return false;

    const session = sessionStateService.session.get();

    if (session?.loggedInAccount?.type === AccountType.Owner && session?.userSummary?.accountCreatedDate) {
      const configValue = await configProvider.getValue('newAccountThresholdDate');

      if (!configValue) {
        LoggerService.logError({ message: 'newAccountThresholdDate config value is missing' });

        return false;
      }

      const configDate = new Date(configValue);
      const accountCreatedDate = new Date(session.userSummary.accountCreatedDate);

      if (isNaN(configDate.getTime()) || isNaN(accountCreatedDate.getTime())) {
        LoggerService.logError({ message: 'Invalid date format in new account check' });

        return false;
      }

      return accountCreatedDate > configDate;
    }

    const result = await newAccountCheckApiService.checkNewAccount();

    return result.isNewAccount;
  } catch (error) {
    LoggerService.logError({ message: 'Failed to check for new account', error });

    return false;
  }
};

export const newAccountCheckService = {
  checkNewAccount,
};
